const DateTimeFunc = require('@/tbs/util/DateTimeFunc')
const ObjectFunc = require('@/tbs/util/ObjectFunc')
const Game = require('@/tbs/model/to/Game')
const game = new Game

/**
 * The Game class acts as the view object for the game.
 */
const tbs_model_vo_Game = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_Game.prototype = {
    /* The view object name */
    name: '',
    /* The view object instance */
    view: {
        manage: [
            {
                name: 'game',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'AdminGetBMMatchGame',
                query: {
                    id: 'id',
                },
                basePath: 'data.game',
                rule: {
                    id: 'id',
                    matchGroupId: 'matchId',
                    seq: '$index',
                    status: '$state',
                    roundSeq: '~round',
                    /*roundTotal: 'gameRoundTotal',*/
                    startDateTime: '$beginDate',
                    homeTeamId: 'homeTeamId',
                    awayTeamId: 'awayTeamId',
                    homeTeamSuit: '$homeClothesColor',
                    awayTeamSuit: '$awayClothesColor',
                    homeTeamName: 'homeTeamName',
                    awayTeamName: 'awayTeamName',
                    homeTeamLogoUrl: 'homeTeamBadge',
                    awayTeamLogoUrl: 'awayTeamBadge',
                    homeTeamScore: '$homeScore,homePenalty',
                    awayTeamScore: '$awayScore,awayPenalty',
                    homeTeamPenaltyScore: '$homePenalty',
                    awayTeamPenaltyScore: '$awayPenalty',
                    matchId: 'unionMatchId',
                    refereeList: '$referee',
                    stageId: '~stageId',
                    roundGroup: 'groupId'
                }
            },
            {
                name: 'match',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'getBMMatchRule',
                query: {
                    id: 'matchGroupId',
                },
                basePath: 'data.match',
                rule: {
                    periodTime: '$semiDuration',
                    dataMode: '$eventMode',
                    dataModeLabel: '$eventMode',
                    roundTotal: '$roundCount',
                }
            },
            {
                name: 'role',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'GetMatchMyManagerRole',
                query: {
                    matchId: 'matchGroupId'
                },
                basePath: 'data',
                rule: {
                    isManager: '@isManager',
                    isReferee: '@isReferee',
                }
            },
        ],
        create: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminCreateBMMatchGame',
            basePath: '',
            rule: {
                matchId: 'matchGroupId',
                stageId: 'stageId',
                groupId: 'roundGroup',
                round: 'roundSeq',
                homeTeamId: 'homeTeamId',
                awayTeamId: 'awayTeamId',
                homeClothesColor: '$homeTeamSuit',
                awayClothesColor: '$awayTeamSuit',
                beginDate: '$startDateTime'
            }
        },
        update: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminUpdateBMMatchGame',
            basePath: '',
            rule: {
                id: 'id',
                matchId: 'matchGroupId',
                stageId: 'stageId',
                groupId: 'roundGroup',
                round: 'roundSeq',
                homeTeamId: 'homeTeamId',
                awayTeamId: 'awayTeamId',
                homeClothesColor: '$homeTeamSuit',
                awayClothesColor: '$awayTeamSuit',
                beginDate: '$startDateTime',
                homeScore: '$homeTeamScore',
                awayScore: '$awayTeamScore',
                homePenalty: '$homeTeamPenaltyScore,homeTeamScore,awayTeamScore',
                awayPenalty: '$awayTeamPenaltyScore,homeTeamScore,awayTeamScore',
                referee: '$refereeList',
            }
        },
        remove: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminDeleteBMMatchGame',
            basePath: '',
            rule: {
                id: 'id'
            }
        },
        getHistoricalScore: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminGetBMMatchGameScoreUpdateRecord',
            query: {
                gameId: 'id'
            },
            method: 'get',
            basePath: 'data.list',
            rule: {
                id: 'id',
                homeTeamScore: '$homeScore',
                awayTeamScore: '$awayScore',
                homeTeamPenaltyScore: '$homePenalty',
                awayTeamPenaltyScore: '$awayPenalty',
                submitName: 'createUserName',
                submitTime: '$createDate'
            }
        },
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    renderSubmitTime: function(createDate) {
        let timeStr = DateTimeFunc.formatDate(new Date(createDate), 'yyyy-MM-dd hh:mm')
        const curretYear = new Date().getFullYear()
        timeStr = timeStr.replace(curretYear + '-', '')
        return timeStr
    },
    renderRefereeList: function(referee) {
        const refereeList = []
        for (let i = 0; i < referee.length; i++) {
            let item = referee[i]
            refereeList.push({roleValue: item.role, optionValue: item.refereeId, optionLabel: item.name})
        }
        return refereeList
    },
    formatReferee: function(refereeList) {
        if (!refereeList) {
            return
        }
        const referees = []
        for (let i = 0; i < refereeList.length; i++) {
            let referee = refereeList[i]
            referees.push({refereeId: referee.optionValue, role: referee.roleValue, name: referee.optionLabel})
        }
        return JSON.stringify(referees)
    },
    renderHomeTeamSuit: function(homeClothesColor) {
        if (homeClothesColor == '0') {
            return ''
        }
        else {
            return homeClothesColor
        }
    },
    renderAwayTeamSuit: function(awayClothesColor) {
        if (awayClothesColor == '0') {
            return ''
        }
        else {
            return awayClothesColor
        }
    },
    formatHomeClothesColor: function(homeTeamSuit) {
        if (homeTeamSuit == '') {
            return '0'
        }
        else {
            return homeTeamSuit
        }
    },
    formatAwayClothesColor: function(awayTeamSuit) {
        if (awayTeamSuit == '') {
            return '0'
        }
        else {
            return awayTeamSuit
        }
    },
    renderStatus: function(state) {
        return (state + 1).toString()
    },
    formatHomeScore: function(homeTeamScore) {
        if (homeTeamScore == null) {
            return
        }
        let score = -1
        if (homeTeamScore) {
            score = Number(homeTeamScore)
        }
        return score
    },
    formatAwayScore: function(awayTeamScore) {
        if (awayTeamScore == null) {
            return
        }
        let score = -1
        if (awayTeamScore) {
            score = Number(awayTeamScore)
        }
        return score
    },
    formatHomePenalty: function(homeTeamPenaltyScore, homeTeamScore, awayTeamScore) {
        if (homeTeamPenaltyScore == null) {
            return
        }
        if (homeTeamPenaltyScore && homeTeamScore == awayTeamScore) {
            return Number(homeTeamPenaltyScore)
        }
        else {
            return -1
        }
    },
    formatAwayPenalty: function(awayTeamPenaltyScore, homeTeamScore, awayTeamScore) {
        if (awayTeamPenaltyScore == null) {
            return
        }
        if (awayTeamPenaltyScore && homeTeamScore == awayTeamScore) {
            return Number(awayTeamPenaltyScore)
        }
        else {
            return -1
        }
    },
    renderSeq: function(index) {
        return ObjectFunc.pad(index, 3)
    },
    renderDataMode: function(eventMode) {
        return (eventMode + 1).toString()
    },
    renderDataModeLabel: function(eventMode) {
        return game.localeProp('data-mode-option-' + (eventMode + 1))
    },
    renderRoundTotal: function(roundCount) {
        return roundCount.toString()
    },
    renderPeriodTime: function(semiDuration) {
        return semiDuration.toString()
    },
    renderHomeTeamPenaltyScore: function(homePenalty) {
        if (homePenalty == -1) {
            return ''
        }
        else {
            return homePenalty.toString()
        }
    },
    renderAwayTeamPenaltyScore: function(awayPenalty) {
        if (awayPenalty == -1) {
            return ''
        }
        else {
            return awayPenalty.toString()
        }
    },
    renderHomeTeamScore: function(homeScore, homePenalty) {
        if (homeScore == -1) {
            return ''
        }
        else {
            if (typeof(homePenalty) == 'number' && homePenalty != -1) {
                return (homeScore - homePenalty).toString()
            }
            else {
                return homeScore.toString()
            }
        }
    },
    renderAwayTeamScore: function(awayScore, awayPenalty) {
        if (awayScore == -1) {
            return ''
        }
        else {
            if (typeof(awayPenalty) == 'number' && awayPenalty != -1) {
                return (awayScore - awayPenalty).toString()
            }
            else {
                return awayScore.toString()
            }
        }
    },
    renderStartDateTime: function(beginDate) {
        return new Date(beginDate)
    },
    formatBeginDate: function(startDateTime) {
        if (startDateTime) {
            return DateTimeFunc.formatDate(new Date(startDateTime), 'yyyy-MM-ddThh:mm:ss+0800')
        }
    },
    getRoundSeqOptions: function(roundList) {
        if (roundList == null) {
            return []
        }
        let roundSeqOptions = []
        for (let i = 0; i < roundList.length; i++) {
            let roundItem = roundList[i]
            roundSeqOptions.push({
                label: game.localeProp('round-seq', {
                    seq: i + 1
                }),
                value: (i + 1).toString(),
                stageId: roundItem.stageId,
                round: roundItem.round,
                isGroupRound: roundItem.isGroupRound,
            })
        }
        return roundSeqOptions
    },
    suitList: [
        { value: '0', label: '无', url: 'http://images.snsports.cn/qy_0.png'},
        { value: '1', label: '白色', url: 'http://images.snsports.cn/qy_1.png'},
        { value: '2', label: '蓝色', url: 'http://images.snsports.cn/qy_2.png'},
        { value: '3', label: '暗红', url: 'http://images.snsports.cn/qy_3.png'},
        { value: '4', label: '深黄', url: 'http://images.snsports.cn/qy_4.png'},
        { value: '5', label: '绿色', url: 'http://images.snsports.cn/qy_5.png'},
        { value: '6', label: '紫色', url: 'http://images.snsports.cn/qy_6.png'},
        { value: '7', label: '橙色', url: 'http://images.snsports.cn/qy_7.png'},
        { value: '8', label: '黑色', url: 'http://images.snsports.cn/qy_8.png'},
        { value: '9', label: '白底黑条纹', url: 'http://images.snsports.cn/qy_9.png'},
        { value: '10', label: '紫底黑条纹', url: 'http://images.snsports.cn/qy_10.png'},
        { value: '11', label: '白底红条纹', url: 'http://images.snsports.cn/qy_11.png'},
        { value: '12', label: '红底黑条纹', url: 'http://images.snsports.cn/qy_12.png'},
        { value: '13', label: '黄底红条纹', url: 'http://images.snsports.cn/qy_13.png'},
        { value: '14', label: '红底紫条纹', url: 'http://images.snsports.cn/qy_14.png'},
        { value: '15', label: '白底蓝条纹', url: 'http://images.snsports.cn/qy_15.png'},
        { value: '16', label: '黄底绿条纹', url: 'http://images.snsports.cn/qy_16.png'},
        { value: '17', label: '白底黑条纹（竖）', url: 'http://images.snsports.cn/qy_17.png'},
        { value: '18', label: '白底红条纹（竖）', url: 'http://images.snsports.cn/qy_18.png'},
        { value: '19', label: '白底黄条纹（竖）', url: 'http://images.snsports.cn/qy_19.png'},
        { value: '20', label: '白底蓝条纹（竖）', url: 'http://images.snsports.cn/qy_20.png'},
        { value: '21', label: '红底黑条纹（竖）', url: 'http://images.snsports.cn/qy_21.png'},
        { value: '22', label: '红底紫条纹（竖）', url: 'http://images.snsports.cn/qy_22.png'},
        { value: '23', label: '黄底黑条纹（竖）', url: 'http://images.snsports.cn/qy_23.png'},
        { value: '24', label: '黄底绿条纹（竖）', url: 'http://images.snsports.cn/qy_24.png'},
        { value: '25', label: '粉红', url: 'http://images.snsports.cn/qy_25.png'},
        { value: '26', label: '天蓝', url: 'http://images.snsports.cn/qy_26.png'},
        { value: '27', label: '浅黄', url: 'http://images.snsports.cn/qy_27.png'}
    ],
    getPeriodOptions: function() {
        return [
            {text: game.localeProp('first-half')},
            {text: game.localeProp('second-half')}
        ]
    },
    getTimeOptions: function(minutes, index) {
        index = index || 0
        const minuteArr = []
        for (let i = 1; i <= minutes; i++) {
            minuteArr.push({text: (i + minutes * index), value: (i + minutes * index).toString()})
        }
        return minuteArr
    },
    getEventTypeOptions: function() {
        return [
            { text: game.localeProp('game-event-type-option-1'), value: '1' },
            { text: game.localeProp('game-event-type-option-2'), value: '2' },
            { text: game.localeProp('game-event-type-option-3'), value: '3' },
            { text: game.localeProp('game-event-type-option-4'), value: '4' },
            { text: game.localeProp('game-event-type-option-5'), value: '5' },
            { text: game.localeProp('game-event-type-option-6'), value: '6' },
            { text: game.localeProp('game-event-type-option-7'), value: '7' },
        ]
    },
    localeProp: function(key, params) {
        return game.localeProp(key, params)
    }
}

module.exports = tbs_model_vo_Game